import { fromJS } from 'immutable';
import httpClient from 'hub-http/clients/apiClient';
const BASE_URI = '/video/v1/portal-video-status';
export const fetchVideo2OptInStatus = () => {
  return httpClient.get(BASE_URI).then(fromJS);
};
export const turnOnVideo = () => {
  return httpClient.post(`${BASE_URI}/opt-in`).then(fromJS);
};
export const turnOffVideo = () => {
  return httpClient.post(`${BASE_URI}/opt-out`).then(fromJS);
};